import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';

/**
 * Class
 */
export default class SubMenuHover extends withBreakpointObserver(Base) {
  /**
   * Class config
   * @type {object}
   */
  static config = {
    name: 'SubMenuHover',
    refs: ['OriginImage', 'ProductImg[]', 'itemHovered[]'],
    activeBreakpoints: {
      type: String,
      default: 'm xl xxl xxxl',
    },
  };

  /**
   * Set variable
   */
  mounted() {
    this.currentSrc = null;
    this.originImage = this.$refs.OriginImage.cloneNode(true); // Clone the original image
  }

  /**
   * [onItemHoveredMouseenter description]
   * @param {Event} event
   * @param {number} ItemIndex
   */
  onItemHoveredMouseenter(event, ItemIndex) {
    this.$refs.OriginImage.classList.remove('is-active');
    this.$refs.ProductImg.forEach((image, imageIndex) =>
      imageIndex === ItemIndex
        ? image.classList.add('is-active')
        : image.classList.remove('is-active'),
    );
  }

  /**
   * [onItemHoveredMouseleave description]
   */
  onItemHoveredMouseleave() {
    this.$refs.ProductImg.forEach((image) => image.classList.remove('is-active'));
    this.$refs.OriginImage.classList.add('is-active');
  }
}
